import './App.css';

function App() {
  return (
    <div className="App">
      <h1 class="Title">Memory Wane</h1>
      <img class="App-logo" style={{border: "black 1px solid", borderRadius: '25px'}} alt="Logo" src="logo512.jpg" />
      <h2 id="pp" class="SubTitle">Privacy Policy</h2>
      <p>
        <i>Effective Date: 4/13/2025</i><br/>
        <br/>
        <strong>1. Introduction</strong><br/>
        Welcome to Memory Wane (“we”, “our”, “us”). Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our app (“App”). By using the App, you agree to the practices described in this Privacy Policy.<br/>
        <br/>
        <i>By using the App, you acknowledge and consent to the practices described in this Privacy Policy and agree to be bound by our <a href="#tos">Terms of Service</a>.</i><br/>
        <br/>
        <strong>2. Information We Collect</strong><br/>
        <i>a. User-Provided Content</i><br/>
        We collect stories and other content that you voluntarily input into the App (“User Content”). This includes any text, characters, or narrative elements you provide.<br/>
        <i>b. Automatically Collected Data</i><br/>
        When you use the App, we may collect limited usage data such as device type, operating system, IP address, and timestamps, solely to ensure functionality, security, and analytics.<br/>
        <br/>
        <strong>3. How We Use Your Information</strong><br/>
        <i>a. Story Processing</i><br/>
        The stories you input are transmitted to OpenAI’s ChatGPT and Whisper APIs to generate structured or enhanced outputs (e.g., summaries, rewrites, or suggestions).<br/>
        <i>b. Storage</i><br/>
        Both your original stories and the ChatGPT-processed results may be stored on our servers to support features like editing, saving progress, sharing, or analysis.<br/>
        <i>c. Improving the App</i><br/>
        We may analyze aggregated, anonymized usage data to improve the performance and user experience of the App.<br/>
        <br/>
        <strong>4. Sharing of Information</strong><br/>
        We do not sell, rent, or trade your personal or story content with third parties. However, we may share information under the following conditions:<br/>
        - With Service Providers: We use third-party service providers, including OpenAI, to process your content. These providers are bound by confidentiality agreements and only process data as instructed.<br/>
        - Legal Requirements: We may disclose your data if required by law, subpoena, or other legal process.<br/>
        - Business Transfers: If our company is involved in a merger, acquisition, or asset sale, your information may be transferred.<br/>
        <br/>
        <strong>5. Data Retention</strong><br/>
        We retain your stories and related data for as long as necessary to:<br/>
        - Provide access to your content<br/>
        - Support App functionality<br/>
        - Comply with legal obligations<br/>
        You may request deletion of your stories at any time by contacting us at <a href="mailto:info@memorywane.com">info@memorywane.com</a>.<br/>
        <br/>
        <strong>6. Your Rights and Choices</strong><br/>
        <i>a. Access and Deletion</i><br/>
        You may request access to or deletion of your stored stories by contacting us.<br/>
        <i>b. Analytics Opt-Out</i><br/>
        Some analytic tools may allow you to opt out of data collection through device settings or browser configurations.<br/>
        <i>c. GDPR and CCPA Compliance</i><br/>
        If you are a resident of the European Economic Area (EEA) or California, you have additional rights under the General Data Protection Regulation (GDPR) and California Consumer Privacy Act (CCPA), including:<br/>
        - The right to know what personal data we collect and how it’s used<br/>
        - The right to request access to, correction of, or deletion of your data<br/>
        - The right to restrict or object to data processing in certain cases<br/>
        - The right to data portability (GDPR)<br/>
        - The right to opt out of the sale or sharing of personal data (CCPA)<br/>
        To exercise these rights, email us at <a href="mailto:info@memorywane.com">info@memorywane.com</a>. We will respond to all valid requests within the timelines required by applicable law.<br/>
        <br/>
        <strong>7. Data Security</strong><br/>
        We implement reasonable administrative, technical, and physical safeguards to protect your data. However, no system is perfectly secure, and we cannot guarantee absolute security.<br/>
        <br/>
        <strong>8. Children's Privacy</strong><br/>
        This App is not intended for use by individuals under the age of 13 (or 16 in some jurisdictions). We do not knowingly collect data from children.<br/>
        <br/>
        <strong>9. International Users</strong><br/>
        If you are accessing the App from outside the United States, you acknowledge that your data may be transferred to and processed in the U.S. or other countries.<br/>
        <br/>
        <strong>10. Changes to This Policy</strong><br/>
        We may update this Privacy Policy from time to time. Changes will be posted in the App or on our website with the updated “Effective Date.”<br/>
        <br/>
        <strong>11. Contact Us</strong><br/>
        If you have any questions or concerns about this Privacy Policy, contact us at:<br/>
        <a href="mailto:info@memorywane.com">info@memorywane.com</a><br/>
      </p>
      <h2 id="tos" class="SubTitle">Terms of Service</h2>
      <p>
        <i>Effective Date: 4/13/2025</i><br/>
        <br/>
        <strong>1. Acceptance of Terms</strong><br/>
        By accessing or using the <strong>Memory Wane</strong> app (“App”), you agree to be bound by these Terms of Service (“Terms”) and our <a href="#pp">Privacy Policy</a>. If you do not agree to these Terms, please do not use the App.<br/>
        <br/>

        <strong>2. Description of the Service</strong><br/>
        Memory Wane provides a platform where users can input written stories, which are then processed using OpenAI’s ChatGPT and Whisper APIs. Processed content may be enhanced, summarized, rewritten, or analyzed. Both original and processed stories may be stored to allow users to edit, review, or share their content within the App.<br/>
        <br/>

        <strong>3. User Responsibilities</strong><br/>
        <i>a. User Content</i><br/>
        You are solely responsible for any content (including stories, text, or media) you submit through the App. By submitting content, you affirm that:<br/>
        - You own the rights to the content or have permission to submit it.<br/>
        - Your content does not violate any applicable laws or infringe on the rights of others.<br/>

        <i>b. Prohibited Uses</i><br/>
        You agree not to use the App to:<br/>
        - Submit content that is defamatory, obscene, hateful, or unlawful<br/>
        - Attempt to reverse-engineer or interfere with the App or its APIs<br/>
        - Upload viruses, malware, or any harmful code<br/>
        - Attempt unauthorized access to our servers or systems<br/>
        <br/>

        <strong>4. Intellectual Property</strong><br/>
        <i>a. Ownership</i><br/>
        All intellectual property rights in the App, including text, software, designs, trademarks, and content generated by the App (excluding your original input), belong to <strong>Memory Wane</strong> or its licensors (e.g., OpenAI).<br/>

        <i>b. License to Your Content</i><br/>
        By using the App, you grant Memory Wane a non-exclusive, worldwide, royalty-free license to store, process, display, and use your submitted content solely for the purpose of operating and improving the App. We do not claim ownership of your stories.<br/>
        <br/>

        <strong>5. Account and Data</strong><br/>
        <i>a. Storage and Access</i><br/>
        Your original and processed stories may be stored on our servers to support features like saving, editing, and accessing past work. You may request deletion of your content at any time by contacting <a href="mailto:info@memorywane.com">info@memorywane.com</a>.<br/>

        <i>b. Data Protection</i><br/>
        Your use of the App is also governed by our <a href="#pp">Privacy Policy</a>, which outlines how we collect, store, and use your data in compliance with applicable laws such as GDPR and CCPA.<br/>
        <br/>

        <strong>6. Third-Party Services</strong><br/>
        The App integrates with third-party services such as OpenAI for natural language processing. Your use of the App may be subject to additional terms from these third-party providers. Memory Wane is not responsible for their services, uptime, or data handling beyond what is disclosed in our Privacy Policy.<br/>
        <br/>

        <strong>7. Termination</strong><br/>
        We reserve the right to terminate or suspend your access to the App, with or without notice, if:<br/>
        - You violate these Terms<br/>
        - We believe your use poses a security risk or violates applicable laws<br/>
        - The service is discontinued or substantially changed<br/>
        <br/>

        <strong>8. Disclaimers and Limitation of Liability</strong><br/>
        <i>a. No Warranty</i><br/>
        The App is provided “as is” and “as available” without warranty of any kind. We make no guarantees regarding accuracy, performance, or suitability for any purpose.<br/>

        <i>b. Limitation of Liability</i><br/>
        To the fullest extent permitted by law, Memory Wane shall not be liable for any indirect, incidental, or consequential damages arising out of your use of the App.<br/>
        <br/>

        <strong>9. Changes to the Terms</strong><br/>
        We may update these Terms from time to time. Continued use of the App after such changes constitutes your acceptance of the updated Terms. You should review this page periodically for any changes.<br/>
        <br/>

        <strong>10. Governing Law</strong><br/>
        These Terms are governed by and construed in accordance with the laws of the State of [Insert State], without regard to its conflict of law provisions.<br/>
        <br/>

        <strong>11. Contact Us</strong><br/>
        If you have any questions about these Terms, please contact us at:<br/>
        <a href="mailto:info@memorywane.com">info@memorywane.com</a><br/>
      </p>
      <h4 className="Footer">&#169; 2025 Memory Wane</h4>
    </div>
  );
}

export default App;
